import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import View from '@/components/view'
import Home from '@/components/home/home'//首页
import Convention from '@/components/system/convention'//常规设置
import Loan from '@/components/system/loan'//常规设置
import Message from '@/components/system/message'//短信设置
import Gathering from '@/components/system/gathering'//收款设置
import Agreement from '@/components/system/agreement'//协议设置
import Order_text_tip from '@/components/order_text_tip/order_text_tip'//订单文字提醒
import User from '@/components/user/user'//用户管理
import Agent from '@/components/agent/agent'//用户管理
import Kefu from '@/components/Kefu/Kefu'//用户管理
import Invite from '@/components/invite/invite'//用户管理
import User_detail from '@/components/user/detail'//用户详情
import Borrow from '@/components/borrow/borrow'//借款列表
import Contract from '@/components/borrow/contract'//合同
import Create_dk_img from '@/components/borrow/create_dk_img'//生成打款截图
import Admin from '@/components/admin/admin'//管理员管理
import Redfile from '@/components/redfile/redfile'//管理员管理
import Wallet_kyc from '@/components/user/wallet_kyc'//钱包kyc
import Order from '@/components/user/order'//订单
import Blind_boxes from '@/components/user/blind_boxes'//盲盒
import CryptoDetail from '@/components/crypto/detail'//加密货币详情
import CryptoRecharge from '@/components/crypto/recharge'//加密货币充值
import BankDetail from '@/components/bank/detail'//银行详情
import BankWithdraw from '@/components/bank/withdraw'//银行提现
import Product_manage from '@/components/product/manage'//产品管理
import History from '@/components/product/history'//历史记录
import Cp_order from '@/components/cp_order/orders'//订单
// import Message_list from '@/components/message/list'//消息列表
Vue.use(Router)

export default new Router({
	mode: 'hash',
	base:'/admin',
	routes: [
		{
			path: '/',
			redirect: '/login',
			component: Login
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/view',
			name: 'view',
			component: View,
			children: [
				{
					path: '/home',
					name: 'home',
					component: Home
				},
				{
					path: '/convention',
					name: 'convention',
					component: Convention
				},
				{
					path: '/Loan',
					name: 'Loan',
					component: Loan
				},
				{
					path: '/gathering',
					name: 'gathering',
					component: Gathering
				},
				{
					path: '/agreement',
					name: 'agreement',
					component: Agreement
				},
				{
					path: '/user',
					name: 'user',
					component: User
				},
				{
					path: '/wallet_kyc',
					name: 'wallet_kyc',
					component: Wallet_kyc
				},
				{
					path: '/order',
					name: 'order',
					component: Order
				},
				{
					path: '/blind_boxes',
					name: 'blind_boxes',
					component: Blind_boxes
				},
				{
					path: '/user_detail',
					name: 'user_detail',
					component: User_detail
				},
				{
					path: '/crypto_detail',
					name: 'crypto_detail',
					component: CryptoDetail
				},
				{
					path: '/crypto_recharge',
					name: 'crypto_recharge',
					component: CryptoRecharge
				},
				{
					path: '/bank_detail',
					name: 'bank_detail',
					component: BankDetail
				},
				{
					path: '/bank_withdraw',
					name: 'bank_withdraw',
					component: BankWithdraw
				},
				{
					path: '/agent',
					name: 'agent',
					component: Agent
				},{
					path: '/kefu',
					name: 'kefu',
					component: Kefu
				},
				{
					path: '/invite',
					name: 'invite',
					component: Invite
				},
				{
					path: '/order_text_tip',
					name: 'order_text_tip',
					component: Order_text_tip
				},
				{
					path: '/borrow',
					name: 'borrow',
					component: Borrow
				},
				{
					path: '/contract',
					name: 'contract',
					component: Contract
				},
				{
					path: '/create_dk_img',
					name: 'create_dk_img',
					component: Create_dk_img
				},
				{
					path: '/admin',
					name: 'admin',
					component: Admin
				},
				{
					path: '/redfile',
					name: 'redfile',
					component: Redfile
				},
				{
					path: '/product_manage',
					name: 'product_manage',
					component: Product_manage
				},
				{
					path: '/history',
					name: 'history',
					component: History
				},
				{
					path: '/cp_order',
					name: 'cp_order',
					component: Cp_order
				}
			]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js